import { render, staticRenderFns } from "./IssueSidebar.vue?vue&type=template&id=679dd2b8&scoped=true&"
import script from "./IssueSidebar.vue?vue&type=script&lang=js&"
export * from "./IssueSidebar.vue?vue&type=script&lang=js&"
import style0 from "./IssueSidebar.vue?vue&type=style&index=0&id=679dd2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679dd2b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679dd2b8')) {
      api.createRecord('679dd2b8', component.options)
    } else {
      api.reload('679dd2b8', component.options)
    }
    module.hot.accept("./IssueSidebar.vue?vue&type=template&id=679dd2b8&scoped=true&", function () {
      api.rerender('679dd2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Issues/IssueSidebar.vue"
export default component.exports